import Parameter from '../Parameter';
import { EnumComboBoxData } from '../Enums/EnumComboBoxData';
import { EnumComboBoxValue } from '../Enums/EnumComboBoxValue';

export default class ComboBoxField extends Parameter {

    public Data: EnumComboBoxData;

    public Value: EnumComboBoxValue;

    /**
     * Dictionnaire
     * @key Nom 
     * @value valeur
     */
    public Options: Array<{ key: string, value: string }>;
    
    /**
     * Constructeur ComboBox
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Data Extends
     * @param Options Extends
     */
    public constructor(Name: string = '', Label: string = '', Type: string = 'ComboBox', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string, value: string }> = [], Data: EnumComboBoxData = EnumComboBoxData.ConsumptionYears, Value: EnumComboBoxValue = EnumComboBoxValue.Last, Options: Array<{ key: string, value: string }> = [] ) {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Data = Data;
        this.Value = Value;
        this.Options = Options;
    }

    //#region Methode Static
    
    // Enregistre la sous-class dans la class Parent
    static {
        Parameter.registerSubclass(ComboBoxField); 
    }

    //#endregion

    /**
     * Check si ComboBox à des valeurs
     * @returns boolean
     */
    override HasValue(): boolean {
        return this.Options.length > 0;
    }

    /**
     * Propriété filtrées pour la création d'un objet ComboBox
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de ComboBox
    override keysToFilter: string[] =  ['Label', 'Data', 'Value'];

    override create() : ComboBoxField{
        return new ComboBoxField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Data, this.Value, this.Options)
    }
}